import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectGrowthChartData, selectRenalConsultationsWithoutVisit } from './pet.selectors';
import { map } from 'rxjs/operators';
import {
  getConsultationsWithoutVisit,
  resetState,
  resetGrowthChart,
  setGrowthChart,
  setGrowthChartNotSavedPastWeights,
} from './pet.actions';
import { Weight } from '@app/core/models';

@Injectable()
export class PetFacade {
  renalConsultationsWithoutVisit$ = this.store$.select(selectRenalConsultationsWithoutVisit);
  growthChartData$ = this.store$.select(selectGrowthChartData);
  canIncludeGrowthChart$ = this.growthChartData$.pipe(map((growthChartData) => !!growthChartData.chartImage));

  constructor(private readonly store$: Store) {}

  getConsultationsWithoutVisit(patientId: string): void {
    this.store$.dispatch(getConsultationsWithoutVisit({ patientId }));
  }

  setGrowthChartNotSavedPastWeights(weight: Weight): void {
    this.store$.dispatch(setGrowthChartNotSavedPastWeights({ weight }));
  }

  setGrowthChart(chartImage: string, chartWeights: Weight[]): void {
    this.store$.dispatch(setGrowthChart({ chartImage, chartWeights }));
  }

  resetGrowthChart(): void {
    this.store$.dispatch(resetGrowthChart());
  }

  resetState(): void {
    this.store$.dispatch(resetState());
  }
}
